export enum AdminLevel {
  system = 0,
  manufacturer = 1,
}
